export default __webpack_public_path__ + "static/media/13.7d2ca761.png";